import React, { useState } from 'react'
import styles from './CourseCard.module.css'
import ActionPanel from './ActionPanel'

const CourseCard = ({ course }) => {
    const [isExpanded, setIsExpanded] = useState(false)

    return (
        <div className={`${styles.card} ${isExpanded ? styles.expanded : ''}`}>
            {/* Header — always visible */}
            <div className={styles.header} onClick={() => setIsExpanded(!isExpanded)}>
                <div className={styles.headerLeft}>
                    <div className={styles.iconContainer}>📚</div>
                    <div className={styles.headerText}>
                        <h3 className={styles.title}>{course.title}</h3>
                        <div className={styles.meta}>
                            {course.provider && <span className={styles.provider}>{course.provider}</span>}
                            {course.provider && course.duration && <span className={styles.dot}>•</span>}
                            {course.duration && <span className={styles.duration}>⏱️ {course.duration}</span>}
                        </div>
                    </div>
                </div>
                <div className={styles.headerRight}>
                    {course.match > 0 && (
                        <div className={styles.matchBadge}>
                            <span className={styles.matchPercent}>{course.match}%</span>
                            <span className={styles.matchLabel}>match</span>
                        </div>
                    )}
                    <button className={styles.expandButton}>
                        {isExpanded ? '▲' : '▼'}
                    </button>
                </div>
            </div>

            {/* Expanded content */}
            {isExpanded && (
                <div className={styles.expandedContent}>
                    {course.whyMatch && course.whyMatch.length > 0 && (
                        <div className={styles.whyMatch}>
                            <h4 className={styles.sectionHeading}>WHY IS IT A STRONG MATCH?</h4>
                            <ul className={styles.matchList}>
                                {course.whyMatch.map((reason, index) => (
                                    <li key={index} className={styles.matchItem}>
                                        <span className={styles.checkIcon}>✓</span>
                                        {reason}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}

                    {course.actions && course.actions.length > 0 && (
                        <ActionPanel actions={course.actions} />
                    )}

                    {course.url && (
                        <a
                            href={course.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.viewLink}
                            onClick={e => e.stopPropagation()}
                        >
                            View Course →
                        </a>
                    )}
                </div>
            )}
        </div>
    )
}

export default CourseCard
